// Reads add_ons[<id>][<key>] fields from a form into the nested object the
// /reservations/quote and /reservations/payment_intent endpoints expect, e.g.
// { "12": { "selected": "1", "tier_id": "4", "quantity": "2" } }. Unchecked
// checkboxes/radios are skipped so unselected add-ons drop out. Shared by the
// reservation-form and stripe-reservation controllers so the live breakdown and
// the actual charge are computed from the same selections.
export function collectAddOnSelections(formEl) {
  const out = {}
  if (!formEl) return out
  formEl.querySelectorAll('[name^="add_ons["]').forEach((el) => {
    const m = el.name.match(/^add_ons\[(\d+)\]\[(\w+)\]$/)
    if (!m) return
    const [, id, key] = m
    if ((el.type === "checkbox" || el.type === "radio") && !el.checked) return
    out[id] = out[id] || {}
    out[id][key] = el.value
  })
  return out
}
